import { IconButton as MuiIconButton } from "@mui/material";

export const IconButton = (props: any) => {
  return <MuiIconButton variant="contained" size="medium" {...props} />;
};
